<template>
    <div>
        <b-modal ref="modal-ajuste-retorno" title="AJUSTAR BONO DE RETORNO" modal-class="modal-primary" hide-footer
            @hidden="$emit('close')" size="md" no-close-on-backdrop no-close-on-esc>

            <ValidationObserver ref="ref-validation-ajuste-retorno">

                <b-row>
                    <b-col md="12" class="mb-2">
                        <div class="d-flex gap-x-3">
                            <span class="text-warning">Viaje: {{ modalData.viaje }}</span>
                            <span class="text-warning">Orden: {{ modalData.orden }}</span>
                        </div>
                        <div class="d-flex">
                            <span>Cliente: {{ modalData.cliente }}</span>
                        </div>
                        <div class="d-flex">
                            <span>Ruta: {{ modalData.ruta }}</span>
                        </div>
                        <div class="d-flex gap-x-3 mt-1">
                            <span>Costo flete original: <b>S/ {{ modalData.costo_flete_original | currency }}</b></span>
                            <span>% original: <b>{{ (modalData.porcentaje_original * 100).toFixed(2) }}%</b></span>
                        </div>
                        <div class="d-flex">
                            <span>Monto original: <b class="text-primary">S/ {{ modalData.monto_original | currency }}</b></span>
                        </div>
                    </b-col>

                    <b-col md="12" class="mb-1">
                        <b-form-checkbox v-model="form.ajustar_costo" class="custom-control-primary">
                            Ajustar costo de flete considerado
                        </b-form-checkbox>
                    </b-col>
                    <b-col lg="12" md="12" v-if="form.ajustar_costo">
                        <validation-provider v-slot="{ errors }" name="costo de flete ajustado"
                            :rules="{ required: form.ajustar_costo, min_value: 0 }">
                            <b-form-group label="Nuevo costo de flete" label-for="costo_flete_ajustado"
                                :state="errors[0] ? false : null">
                                <money id="costo_flete_ajustado" v-model="form.costo_flete_ajustado" v-bind="moneyConfig"
                                    class="form-control w-100 form-control-md" />
                            </b-form-group>
                        </validation-provider>
                    </b-col>

                    <b-col md="12" class="mb-1">
                        <b-form-checkbox v-model="form.ajustar_porcentaje" class="custom-control-primary">
                            Ajustar porcentaje aplicado
                        </b-form-checkbox>
                    </b-col>
                    <b-col lg="12" md="12" v-if="form.ajustar_porcentaje">
                        <validation-provider v-slot="{ errors }" name="porcentaje ajustado"
                            :rules="{ required: form.ajustar_porcentaje, min_value: 0, max_value: 100 }">
                            <b-form-group label="Nuevo porcentaje (%)" label-for="porcentaje_ajustado"
                                :state="errors[0] ? false : null">
                                <b-form-input id="porcentaje_ajustado" type="number" step="0.01" min="0" max="100"
                                    v-model="form.porcentaje_ajustado" />
                            </b-form-group>
                        </validation-provider>
                    </b-col>

                    <b-col md="12" lg="12">
                        <ValidationProvider v-slot="{ errors }" rules="required|max:400" name="motivo">
                            <b-form-group label="Motivo del ajuste" label-for="motivo_ajuste"
                                :state="errors[0] ? false : null">
                                <b-form-textarea id="motivo_ajuste" v-model="form.motivo_ajuste" rows="3"
                                    :class="{ 'border-danger': errors[0] }" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

            </ValidationObserver>

            <div class="text-center mt-1">
                <b-button variant="outline-success" @click="guardarAjuste">GUARDAR AJUSTE</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";

export default {
    mixins: [modalMixin],
    props: {
        modalData: {
            type: Object,
            require: true,
        },
    },
    data() {
        return {
            moneyConfig: {
                decimal: ".",
                thousands: ",",
                prefix: "S/.",
                precision: 2,
                masked: false,
            },
            form: {
                ajustar_costo: false,
                costo_flete_ajustado: 0,
                ajustar_porcentaje: false,
                porcentaje_ajustado: 0,
                motivo_ajuste: null,
            },
        };
    },
    mounted() {
        this.toggleModal("modal-ajuste-retorno");

        const tieneAjusteCosto = this.modalData.costo_flete_ajustado !== null && this.modalData.costo_flete_ajustado !== undefined;
        const tieneAjustePorcentaje = this.modalData.porcentaje_ajustado !== null && this.modalData.porcentaje_ajustado !== undefined;

        this.form.ajustar_costo = tieneAjusteCosto;
        this.form.costo_flete_ajustado = tieneAjusteCosto
            ? Number(this.modalData.costo_flete_ajustado)
            : Number(this.modalData.costo_flete_original);

        this.form.ajustar_porcentaje = tieneAjustePorcentaje;
        this.form.porcentaje_ajustado = tieneAjustePorcentaje
            ? Number(this.modalData.porcentaje_ajustado) * 100
            : Number(this.modalData.porcentaje_original) * 100;

        this.form.motivo_ajuste = this.modalData.motivo_ajuste || null;
    },
    methods: {
        async guardarAjuste() {
            try {
                if (!this.form.ajustar_costo && !this.form.ajustar_porcentaje) {
                    this.showToastError("Debe seleccionar al menos un tipo de ajuste (costo y/o porcentaje).");
                    return;
                }

                const result = await this.$refs["ref-validation-ajuste-retorno"].validate();
                if (!result) return;

                const confirm = await this.showConfirmSwal();
                if (!confirm.isConfirmed) return;

                this.addPreloader();

                const { data } = await BonoService.ajustarRetorno({
                    id: this.modalData.id,
                    costo_flete_ajustado: this.form.ajustar_costo ? this.form.costo_flete_ajustado : null,
                    porcentaje_ajustado: this.form.ajustar_porcentaje ? this.form.porcentaje_ajustado / 100 : null,
                    motivo_ajuste: this.form.motivo_ajuste,
                });

                this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: this.$t(data.message),
                        icon: "CoffeeIcon",
                        variant: "success",
                        text: this.$t(data.message),
                    },
                });

                this.$emit("refresh");
            } catch (error) {
                this.showToastError(error?.response?.data?.message);
            } finally {
                this.removePreloader();
            }
        },
    },
};
</script>
